/** Stable identifier for the not-configured branch — caught by import wizards and planner UI. */
export class AiNotConfiguredError extends Error {
  public readonly originalError?: unknown;
  constructor(originalError?: unknown) {
    super("Firebase AI Logic is not configured for this project.");
    this.name = "AiNotConfiguredError";
    this.originalError = originalError;
  }
}

/**
 * AIError carries a `code` string (e.g. "ai/fetch-error") and, for HTTP
 * failures, a `customErrorData.status` number. Only hard configuration /
 * permission errors are treated as AiNotConfiguredError.
 */
export function isConfigError(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const e = err as Record<string, unknown>;
  const code = typeof e["code"] === "string" ? e["code"] : "";
  if (code.includes("no-api-key") || code.includes("no-project-id")) return true;
  if (code.includes("fetch-error")) {
    const data = e["customErrorData"] as Record<string, unknown> | undefined;
    const status = typeof data?.["status"] === "number" ? data["status"] : 0;
    return status === 400 || status === 403 || status === 404;
  }
  return false;
}
